<template>
    <div v-if="auth.user.is_developer" class="flex flex-col space-y-2 text-gray-200">
        <span class="font-bold">Developer Panel</span>

        <default-button color="red" @click.native="triggerError">Trigger error</default-button>

        <toggle v-model="auth.user.is_admin" name="is_admin" label="Admin" active-color="bg-green-600"/>

        <div class="flex flex-col text-sm">
            <span class="font-bold">Roles</span>
            <span v-for="role in auth.user.roles">{{ role.label }}</span>
        </div>

        <div class="text-sm" v-if="auth.user.stores.length > 0">
            <span class="font-bold">Stores</span>
            <div class="flex flex-wrap space-x-1">
                <span v-for="store in auth.user.stores">#{{ store.number }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        triggerError() {
            throw new Error('Test Error');
        },
    },
};
</script>
